import React from "react"
import PropTypes from "prop-types"
import { DateTime } from "luxon"
import { Link } from "gatsby"
import { Image, Box, Text } from "rebass"
import styled from "styled-components"

import { theme } from "./Layout"

const Title = styled.h1`
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  margin: 20px auto 0 auto;
  width: 90%;
  color: black;
`

const BlogThumb = ({
  title,
  publishDate,
  featuredImage,
  excerpt,
  slug,
  bodyES,
  language,
}) => {
  let esExcerpt = bodyES ? bodyES.replace(/<\/?[^>]+(>|$)/g, "") : excerpt
  esExcerpt = esExcerpt.substring(0, 200)

  return (
    <Box
      as="article"
      sx={{
        px: "20px",
        my: "20px",
        textAlign: "center",
        ">a": { textDecoration: "none" },
      }}
    >
      <Link to={slug}>
        <Image
          src={featuredImage}
          alt={title}
          sx={{
            transition: "all .5s ease",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        />
      </Link>
      <Link to={slug}>
        <Title>{title}</Title>
      </Link>
      <Text
        as="small"
        sx={{
          textTransform: "capitalize",
          display: "inline-block",
          my: 2,
          color: `${theme.colors.info}`,
        }}
      >
        {DateTime.fromISO(publishDate).toFormat("MMMM dd, yyyy", {
          locale: language === "es_MX" ? "es" : "en",
        })}
      </Text>

      <Text
        as="p"
        sx={{
          color: `${theme.colors.info}`,
          mt: 3,
          fontSize: 1,
          lineHeight: 1.5,
        }}
      >
        {language === "es_MX" ? `${esExcerpt}...` : excerpt}
      </Text>
    </Box>
  )
}

BlogThumb.propTypes = {
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  featuredImage: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  bodyES: PropTypes.string.isRequired,
  language: PropTypes.string,
}

BlogThumb.defaultProps = {
  language: "en",
}

export default BlogThumb
